module.exports = __webpack_public_path__ + "static/media/post_video.7b20c549.svg";